/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {
  AssetState,
  DeviceState,
  EntityStatus
} from '@ion/core/src/types/entities';
import {IconStatus} from '../types/types';
/**
 * Defines a mapping of asset states to their respective icon status colors.
 */
export const assetStateColorMap = {
  [AssetState.ACTIVE]      : IconStatus.active,
  [AssetState.TOWED]       : IconStatus.towed,
  [AssetState.IDLE]        : IconStatus.idle,
  [AssetState.PARKED]      : IconStatus.parked,
  [AssetState.MOVING]      : IconStatus.active,
  [AssetState.NOGPS]       : IconStatus.nogps,
  [EntityStatus.Enabled]   : IconStatus.active,
  [DeviceState.STATIONARY] : IconStatus.parked,
  [DeviceState.MOVING]     : IconStatus.active
};

export default assetStateColorMap;
